import Highway from '@dogstudio/highway';

export default class SingleBoutique extends Highway.Renderer {

  onEnter() {
    console.log('SingleBoutique');
    this.DOM = { view: this.wrap.lastElementChild };
    this.DOM.header = document.querySelector('.Header');
    this.DOM.header.classList.add('is--dark');
  }

  onLeaveCompleted() {
    this.DOM.header.classList.remove('is--dark');
  }
}
